import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { AttendancePhotosForSessionQuery, FindAttendancePhotoQuery } from '../queries/generated';

@Injectable({
  providedIn: 'root'
})
export class AttendancePhotosService {
  /// Queries (reading data)
  private readonly findAttendancePhotoQuery = inject(FindAttendancePhotoQuery);
  private readonly forSessionQuery = inject(AttendancePhotosForSessionQuery);

  find(id: string) {
    return this.findAttendancePhotoQuery
      .watch({ id })
      .valueChanges.pipe(map(({ data }) => data.attendancePhotos.findById));
  }

  forSession(id: string, ignoreCache = false) {
    const fetchPolicy = ignoreCache ? 'network-only' : 'cache-first';

    return this.forSessionQuery
      .watch({ id }, { fetchPolicy })
      .valueChanges.pipe(map(({ data }) => data.sessions.findById.attendancePhotos.nodes));
  }
}
